/* eslint-disable no-undef */
import React, { useEffect, useRef } from 'react'
import { useAppSelector } from '../../app/hooks'
import sensors from '../../utils/sensors'
import * as MapUtils from '../../utils/mapUtils'

interface MapContainerProps {
  afterMapInit: () => void
}

function MapContainer(props: MapContainerProps) {
  const { afterMapInit } = props
  const groupId = useAppSelector((state) => state.group.groupId)
  const customInfoWindowRef = useRef(null)
  const afterMapInitRef = useRef(afterMapInit)
  afterMapInitRef.current = afterMapInit

  useEffect(() => {
    const initMap = () => {
      window.MapInstance = new (AMap as any).Map('map-container', {
        mapStyle: 'amap://styles/light'
      })
      window.MapInstance.addControl(new (AMap as any).ToolBar())
      window.MapInfoWindow = new (AMap as any).InfoWindow({
        isCustom: true,
        offset: new (AMap as any).Pixel(0, -48)
      })
      afterMapInitRef.current()
      if (window.initAMapUI) window.initAMapUI()
      if (window.AMapUI) {
        ;(AMapUI as any).loadUI(
          ['control/BasicControl'],
          (BasicControl: any) => {
            const LayerSwitcherCtrl = new BasicControl.LayerSwitcher({
              position: 'rt' //right top，右上角
            })
            LayerSwitcherCtrl.on(
              'layerPropChanged',
              ({ layer }: { layer: { enable: boolean; id: string } }) => {
                if (layer.enable && layer.id === 'tile') {
                  sensors.track('web_pathway_homepage_click', {
                    clickItem: 'mapTypeStandard',
                    groupID: groupId
                  })
                }
                if (layer.enable && layer.id === 'satellite') {
                  sensors.track('web_pathway_homepage_click', {
                    clickItem: 'mapTypeSatellite',
                    groupID: groupId
                  })
                }
              }
            )
            window.MapInstance &&
              window.MapInstance.addControl(LayerSwitcherCtrl)
          }
        )
      }
    }

    MapUtils.loadGaodeSDK('onAMapLoad', initMap)
    // 地图只初始化一次，不随 afterMapInit/groupId 变化重建
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <div className="map-container" id="map-container"></div>
}

export default MapContainer
